import { Routes } from "@angular/router";
import { IntegrationAppsComponent } from "./integration-apps.component";
import { AuthGuard } from "../auth/auth.guard";
import { IntegrationAppsHubComponent } from "./pages/integration-apps-hub/integration-apps-hub.component";
import { IntegrationAppsMarketplaceComponent } from "./pages/integration-apps-marketplace/integration-apps-marketplace.component";
import { IntegrationAppsDetailsComponent } from "./pages/integration-apps-details/integration-apps-details.component";
import { IntegrationAppsCreationEditorComponent } from "./pages/integration-apps-creation-editor/integration-apps-creation-editor.component";

export const integrationAppsRouting: Routes = [
    {
        path: 'integration-apps', component: IntegrationAppsComponent, canActivate: [AuthGuard], children: [
            { path: 'hub', component: IntegrationAppsHubComponent, canActivate: [AuthGuard] },
            { path: 'marketplace', component: IntegrationAppsMarketplaceComponent, canActivate: [AuthGuard] },
            { path: 'details/:appId', component: IntegrationAppsDetailsComponent, canActivate: [AuthGuard] },
            { path: 'create', component: IntegrationAppsCreationEditorComponent, canActivate: [AuthGuard] },
            { path: 'newversion/:appId', component: IntegrationAppsCreationEditorComponent, canActivate: [AuthGuard] },

            { path: '', redirectTo: 'hub', pathMatch: 'full' },
            { path: '**', redirectTo: 'hub', pathMatch: 'full' }
        ]
    },
]